import React, { useEffect, useRef, useState } from "react";
import hljs from "highlight.js";

import { createAdminCoupons, createAdminCouponsApi, updateShippingApi } from "../../apiHelper/authService";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { clearSelectedCoupon, clearSelectedPackage, clearSelectedShippingCharge } from "../../redux/authModalSlice";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
const CreateCoupons = () => {

    const [submitLoading, setSubmitLoading] = useState(false)


    const [id, setId] = useState("")

    const [formData, setFormData] = useState({
        couponCode: '',
        summary: '',
        minOrderValue: '',
        maxOrderValue: '',
        minOrderQty: '',
        userUsageLimit: '',
        expiryDate: '',
        discountType: 'Dollar',
        discountValue: '',
        visibleToUsers: 'No',
        notifyUsers: 'No',

        restrictUsers: 'No',
        maxUserValue: "",
        desc1: '',
        desc2: '',
        desc3: '',
        desc4: ''
    });

    const [formErrors, setFormErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        const updatedForm = { ...formData, [name]: value };
        setFormData(updatedForm);
        validateField(name, value);
    };

    const validateField = (name, value) => {
        const errors = { ...formErrors };

        const numberFields = [
            'minOrderValue',
            'maxOrderValue',
            'minOrderQty',
            'userUsageLimit',
            'discountValue',
            'maxUserValue'
        ];

        if (numberFields.includes(name)) {
            if (!/^\d+(\.\d{1,2})?$/.test(value)) {
                errors[name] = 'Must be a valid number';
            } else {
                delete errors[name];
            }
        } else if (!value && !['desc2', 'desc3', 'desc4'].includes(name)) {
            if (name === 'maxUserValue' && formData.restrictUsers !== 'Yes') {
                delete errors[name]; // Not required when restrictUsers !== Yes
            } else {
                errors[name] = 'This field is required';
            }
        } else {
            delete errors[name];
        }

        setFormErrors(errors);
    };


    const navigate = useNavigate()

    const { selectedShippingCharge } = useSelector((state) => state.authModal);
    const { selectedCoupon } = useSelector((state) => state.authModal);

    const { user } = useSelector((state) => state.authModal);
    const fromCountry = user?.from;
    const toCountry = user?.to;

    const [shippingId, setShippingId] = useState('')


    const dispatch = useDispatch()

    useEffect(() => {
        // Load highlight.js configuration and signal when ready
        hljs?.configure({
            languages: [
                "javascript",
                "ruby",
                "python",
                "java",
                "csharp",
                "cpp",
                "go",
                "php",
                "swift",
            ],
        });
    }, []);






    const [intCharges, setIntCharges] = useState('');
    const [locCharges, setLocCharges] = useState('');
    const [taxes, setTaxes] = useState('');


    const [selectedUnit, setSelectedUnit] = useState("AIR");











    const handleSubmit = async (e) => {
        e.preventDefault();

        const errors = {};

        Object.keys(formData).forEach((key) => {
            const value = formData[key];

            // Skip optional description fields
            if (['desc2', 'desc3', 'desc4'].includes(key)) return;

            // Conditionally skip maxUserValue if not needed
            if (key === 'maxUserValue' && formData.restrictUsers !== 'Yes') return;

            // Required field check
            if (!value) {
                errors[key] = 'This field is required';
                return;
            }

            // Validate numeric fields
            if (
                ['minOrderValue', 'maxOrderValue', 'minOrderQty', 'userUsageLimit', 'discountValue', 'maxUserValue'].includes(key)
            ) {
                if (!/^\d+(\.\d{1,2})?$/.test(value)) {
                    errors[key] = 'Must be a valid number';
                }
            }
        });

        // 🔥 Update state here so errors show up in UI
        setFormErrors(errors);




        if (Object.keys(errors).length === 0) {

            const payloadData = {
                amount: parseInt(formData?.discountValue),
                coupon_description: formData?.summary,
                coupon_name: formData?.couponCode,
                discription1: formData?.desc1,
                expiration_date: new Date(formData?.expiryDate).toISOString(),

                forShipment: true,
                isLimited: formData?.restrictUsers === "Yes" ? true : false,
                isPublic: formData?.visibleToUsers === "Yes" ? true : false,

                max_order_amount: parseInt(formData?.maxOrderValue),
                max_redemptions: parseInt(formData?.maxUserValue),
                min_order_amount: parseInt(formData?.minOrderValue),
                min_order_quantity: parseInt(formData?.minOrderQty),
                type: formData?.discountType === "Percentage" ? true : false,
                user_usage_count: parseInt(formData?.userUsageLimit),
                usersendMail: formData?.notifyUsers === "Yes" ? true : false,

                id: id

                // forShipment:formData?.


            }
            try {
                setSubmitLoading(true)
                const res = await createAdminCouponsApi(payloadData);
                console.log('Success:', res);
                // toast.success(res.message || "Success");
                navigate("/coupons-management");
            } catch (err) {
                toast.error(err || "Something went wrong");
                console.error('Error:', err);
            }

            finally {
                setSubmitLoading(false)
            }
        } else {
            console.log('Errors:', errors);
        }
    };

    console.log("Selected Coupon Details", selectedCoupon)




    useEffect(() => {
        if (selectedCoupon) {


            setFormData({
                couponCode: selectedCoupon?.coupon_name || '',
                summary: selectedCoupon?.coupon_description || '',
                minOrderValue: selectedCoupon?.min_order_amount || '',
                maxOrderValue: selectedCoupon?.max_order_amount || '',
                minOrderQty: selectedCoupon?.min_order_quantity || '',
                userUsageLimit: selectedCoupon?.user_usage_count || '',
                expiryDate: selectedCoupon?.expiration_date
                    ? new Date(selectedCoupon.expiration_date).toISOString().split("T")[0]
                    : '',

                discountType: selectedCoupon?.type === "PERCENTAGE" ? "Percentage" : "Dollar" || 'Dollar',
                discountValue: selectedCoupon?.amount || '',
                visibleToUsers: selectedCoupon?.isPublic ? "Yes" : "No" || 'No',
                notifyUsers: 'No',

                restrictUsers: selectedCoupon?.isLimited ? "Yes" : "No" || 'No',
                maxUserValue: selectedCoupon?.max_redemptions || "",
                desc1: selectedCoupon?.discription1 || '',
                desc2: selectedCoupon?.discription2 || '',
                desc3: selectedCoupon?.discription3 || '',
                desc4: selectedCoupon?.discription4 || ''
            })


            setId(selectedCoupon?.id)













        }

        return () => {

            dispatch(clearSelectedCoupon());
        };
    }, [selectedCoupon, dispatch]);


    function getTotalVal(taxPercent, internationCharge, localCharge) {
        const international = Number(internationCharge);
        const local = Number(localCharge);
        const tax = Number(taxPercent);

        const subtotal = international + local;
        const taxAmount = (subtotal * tax) / 100;
        const total = subtotal + taxAmount;

        return Number(total.toFixed(2)); // Optional: rounds to 2 decimal places
    }


    const handleNumericInput = (e, setter) => {
        const value = e.target.value;

        if (/^\d*\.?\d*$/.test(value)) {
            setter(value);
        }
    };


    return (
        <div className='row gy-4'>
            <div className='col-lg-12'>
                <div className='card mt-24'>
                    <div className='card-header border-bottom'>
                        <h6 className='text-xl mb-0'>Create Coupons</h6>
                    </div>
                    <div className='card-body p-24'>
                        <form onSubmit={handleSubmit} className='d-flex flex-column gap-20'>
                            <div className="row">
                                {[
                                    { name: 'couponCode', label: 'Coupon Code', type: 'text', },
                                    { name: 'summary', label: 'Coupon Summary', type: 'text' },
                                    { name: 'minOrderValue', label: 'Minimum Order Value', type: 'text', numeric: true },
                                    { name: 'maxOrderValue', label: 'Maximum Order Value', type: 'text', numeric: true },
                                    { name: 'minOrderQty', label: 'Minimum Order Quantity', type: 'text', numeric: true },
                                    { name: 'userUsageLimit', label: 'User Usage Limit', type: 'text', numeric: true },
                                    { name: 'expiryDate', label: 'Expiry Date', type: 'date' }
                                ].map(({ name, label, type = 'text', numeric }) => (
                                    <div className="col-12 col-md-6 mb-3" key={name}>
                                        <label className="form-label fw-bold text-neutral-900">{label}</label>
                                        <input
                                            type={type}
                                            name={name}
                                            inputMode={numeric ? 'numeric' : 'text'}
                                            onKeyPress={(e) => {
                                                if (numeric && !/[0-9]/.test(e.key)) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            className="form-control border border-neutral-200 radius-8"
                                            placeholder={`Enter ${label}`}
                                            value={formData[name]}
                                            onChange={handleChange}
                                            min={type === "date" ? new Date().toISOString().split("T")[0] : undefined}
                                        />
                                        {formErrors[name] && <small className="text-danger">{formErrors[name]}</small>}
                                    </div>
                                ))}
                            </div>


                            <div className="row">
                                <div className="col-md-4 mb-3">
                                    <label className='form-label fw-bold'>Discount Type</label>
                                    <select
                                        name="discountType"
                                        className='form-control'
                                        value={formData.discountType}
                                        onChange={handleChange}
                                    >
                                        <option value="Dollar">Dollar</option>
                                        <option value="Percentage">Percentage</option>
                                    </select>
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label className='form-label fw-bold'>Discount Value</label>
                                    <div className="input-group">
                                        <span className="input-group-text">
                                            {formData.discountType === 'Dollar' ? '$' : '%'}
                                        </span>
                                        <input
                                            type="text"
                                            name="discountValue"
                                            className='form-control'
                                            value={formData.discountValue}
                                            onChange={handleChange}
                                            placeholder="Enter discount value"
                                        />
                                    </div>
                                    {formErrors.discountValue && <small className="text-danger">{formErrors.discountValue}</small>}
                                </div>
                            </div>

                            <div className="row">
                                {[
                                    { name: 'visibleToUsers', label: 'Visible in User Coupons' },
                                    { name: 'notifyUsers', label: 'Notify Users via Email' },

                                    { name: 'restrictUsers', label: 'Restrict to Limited Users' }
                                ].map(({ name, label }) => (
                                    <div className="col-12 col-md-4 mb-3" key={name}>
                                        <label className='form-label fw-bold'>{label}</label>
                                        <select
                                            name={name}
                                            className='form-control'
                                            value={formData[name]}
                                            onChange={handleChange}
                                        >
                                            <option value="No">No</option>
                                            <option value="Yes">Yes</option>
                                        </select>
                                    </div>
                                ))}
                            </div>


                            {formData.restrictUsers === "Yes" && (
                                <div className="col-12 col-md-4 mb-3">
                                    <label className="form-label fw-bold" htmlFor="maxUserValue">
                                        Maximum User Value
                                    </label>
                                    <input
                                        type="number"
                                        name="maxUserValue"
                                        id="maxUserValue"
                                        placeholder="Enter Maximum Users"
                                        className="form-control"
                                        value={formData.maxUserValue}
                                        onChange={handleChange}
                                        min={1}
                                    />
                                    {formErrors.maxUserValue && (
                                        <small className="text-danger">{formErrors.maxUserValue}</small>
                                    )}
                                </div>
                            )}

                            <div className="row">
                                {[1, 2, 3, 4].map((i) => (
                                    <div className="col-12 mb-3" key={`desc${i}`}>
                                        <label className='form-label fw-bold'>Coupon Description Point {i}</label>
                                        <input
                                            type='text'
                                            name={`desc${i}`}
                                            className='form-control border border-neutral-200 radius-8'
                                            placeholder={i === 1 ? "Required" : "Optional"}
                                            value={formData[`desc${i}`]}
                                            onChange={handleChange}
                                        />
                                        {(i === 1 && formErrors[`desc${i}`]) && <small className="text-danger">{formErrors[`desc${i}`]}</small>}
                                    </div>
                                ))}
                            </div>

                            <button type='submit' className='btn btn-primary-600 radius-8 col-md-2'>Submit</button>
                        </form>
                    </div>
                </div>
            </div>


        </div>
    );
};

export default CreateCoupons;
